<template>
    <common-fuzzy :param="param" :obj="obj" @change="cb"></common-fuzzy>
</template>

<script>
    import help from '@/util/help'
    export default {
        props: ['obj'],
        data() {
            return {
                param: {
                    api: 'bill/catalog/findCatalogPage',
                    query: {

                    },
                    cols: [
                        {
                            key: 'id',
                            value: '主键',
                            minWidth: 100,
                            searchNormal: true,
                        },
                        {
                            key: 'catalogName',
                            value: '名称',
                            minWidth: 100,
                            searchNormal: true,
                        },
                        {
                            key: 'headId',
                            value: '父ID',
                            minWidth: 100,
                            searchNormal: true,
                        },
                        {
                            key: 'articleCheckTypeName',
                            value: '文章是否需要审核',
                            minWidth: 100,
                            searchNormal: true,
                        },
                        {
                            key: 'commentTypeName',
                            value: '评论控制',
                            minWidth: 100,
                            searchNormal: true,
                        },
                        {
                            key: 'commentCheckTypeName',
                            value: '评论是否需要审核',
                            minWidth: 100,
                            searchNormal: true,
                        },
                    ],
                }
            }
        },
        inject: ['ins'],
        methods: {
            cb(data) {
                help.execFuncByParent(this, 'fuzzyCatalog', data);
            }
        }
    }
</script>

<style scoped>

</style>
